/*
 * Shipping cost and delivery estimate before checkout (roadmap 0a).
 * Markup and rules: snippets/tpm-shipping-info.liquid.
 */
(function () {
  'use strict';

  if (window.tpmShippingInfo) return;
  window.tpmShippingInfo = true;

  // Embossers: digital preview the same business day for orders placed by
  // 5 pm Pacific, ships the next business day after approval, then USPS
  // Ground Advantage takes 2-5 business days. So, counted from the order
  // day: 3 business days at best, 6 at most (if the preview is approved the
  // same day).
  var CUTOFF_HOUR_PACIFIC = 17;
  var MIN_BUSINESS_DAYS = 3;
  var MAX_BUSINESS_DAYS = 6;

  // USPS holidays (observed dates). Extend before the end of 2027.
  var HOLIDAYS = [
    '2026-10-12', '2026-11-11', '2026-11-26', '2026-12-25',
    '2027-01-01', '2027-01-18', '2027-02-15', '2027-05-31', '2027-06-18',
    '2027-07-05', '2027-09-06', '2027-10-11', '2027-11-11', '2027-11-25',
    '2027-12-24'
  ];

  // Dates are UTC midnights standing for Pacific calendar days.
  function pacificNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (part) {
      parts[part.type] = part.value;
    });
    return {
      day: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)),
      hour: +parts.hour
    };
  }

  function isBusinessDay(day) {
    var weekday = day.getUTCDay();
    return weekday !== 0 && weekday !== 6 &&
      HOLIDAYS.indexOf(day.toISOString().slice(0, 10)) === -1;
  }

  function addBusinessDays(day, count) {
    var result = new Date(day.getTime());
    while (count > 0) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (isBusinessDay(result)) count--;
    }
    return result;
  }

  function deliveryRangeText() {
    var now = pacificNow();
    var orderDay = now.day;
    if (!isBusinessDay(orderDay) || now.hour >= CUTOFF_HOUR_PACIFIC) {
      orderDay = addBusinessDays(orderDay, 1);
    }
    var first = addBusinessDays(orderDay, MIN_BUSINESS_DAYS);
    var last = addBusinessDays(orderDay, MAX_BUSINESS_DAYS);
    var month = function (day) {
      return day.toLocaleDateString('en-US', { month: 'short', timeZone: 'UTC' });
    };

    if (first.getUTCMonth() === last.getUTCMonth()) {
      return month(first) + ' ' + first.getUTCDate() + '–' + last.getUTCDate();
    }
    return month(first) + ' ' + first.getUTCDate() + ' – ' + month(last) + ' ' + last.getUTCDate();
  }

  function showDeliveryDates() {
    var lines = document.querySelectorAll('[data-tpm-delivery]');
    if (!lines.length) return;

    var text = deliveryRangeText();
    Array.prototype.forEach.call(lines, function (line) {
      line.querySelector('[data-tpm-delivery-range]').textContent = text;
      line.hidden = false;
    });
  }

  // Same rules as the cart branch of snippets/tpm-shipping-info.liquid.
  function cartSummary(cart, kinds, freeFrom) {
    var hasShippingItems = false;
    var hasRas = false;
    var onlyEmbossers = true;
    var onlyStampsAndEmbossers = true;

    cart.items.forEach(function (item) {
      if (!item.requires_shipping) return;
      hasShippingItems = true;
      var kind = kinds[item.key] || 'other';
      if (kind === 'ras') {
        hasRas = true;
      } else if (kind === 'custom') {
        onlyEmbossers = false;
      } else if (kind !== 'embosser') {
        onlyEmbossers = false;
        onlyStampsAndEmbossers = false;
      }
    });

    var mode = 'fallback';
    if (hasShippingItems && !hasRas) {
      if (cart.total_price >= freeFrom) {
        mode = 'free';
      } else if (onlyStampsAndEmbossers) {
        mode = 'flat';
      }
    }
    return { mode: mode, estimate: onlyEmbossers };
  }

  function updateCartShipping(cart) {
    var box = document.querySelector('[data-tpm-cart-shipping]');
    if (!box || !cart || !cart.items) return;

    var kinds;
    try {
      kinds = JSON.parse(box.getAttribute('data-kinds'));
    } catch (error) {
      return;
    }
    var summary = cartSummary(cart, kinds, +box.getAttribute('data-free-from'));
    box.setAttribute('data-mode', summary.mode);
    box.setAttribute('data-estimate', String(summary.estimate));
  }

  showDeliveryDates();

  // The cart page changes quantities through jQuery Ajax (assets/app.js.liquid)
  // without reloading, so recompute when the cart API answers. jQuery loads
  // after this script (end of layout/theme.liquid), hence DOMContentLoaded.
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.jQuery || !document.querySelector('[data-tpm-cart-shipping]')) return;
    window.jQuery(document).on('ajaxSuccess', function (_event, _xhr, settings, data) {
      if (/\/cart\/(change|update)(\.js)?/.test(settings.url || '')) {
        updateCartShipping(data);
      }
    });
  });
})();
